import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getMyRankings, fetchTop, fetchRangeUser, getRankingByInviteCode } from '../service/ranking';
import { loading } from '@actions';

export const INVITE_LOCALSTORAGE_KEY = 'invite';

export const loadMyRankings = reload => (dispatch, getState) => {
  let { jwToken, user, rankings } = getState();

  if (isEmpty(user)) return; // if there's no user don't fetch

  if (!reload && !isEmpty(rankings)) {
    return rankings;
  }

  dispatch(loading(true));
  return getMyRankings(jwToken, user._id).then(res => {
    dispatch({
      type: 'RANKINGS_SET',
      payload: get(res, 'data.data', [])
    });
    dispatch(loading(false));
    return res;
  });
};

export const loadTop = () => (dispatch, getState) => {
  let { globalRanking } = getState();

  if (!isEmpty(get(globalRanking, 'top'))) {
    return globalRanking.top;
  }

  return fetchTop().then(res => {
    dispatch({
      type: 'GLOBAL_RANKING_TOTAL_SET',
      payload: get(res, 'data.total', 0)
    });

    dispatch({
      type: 'GLOBAL_RANKING_TOP_SET',
      payload: get(res, 'data.data', [])
    });
    return res;
  });
};

export const loadMyRange = () => (dispatch, getState) => {
  let { jwToken, user, globalRanking } = getState();

  if (!isEmpty(get(globalRanking, 'myRange'))) {
    return globalRanking.myRange;
  }

  return fetchRangeUser(jwToken, user._id).then(res => {
    dispatch({
      type: 'GLOBAL_RANKING_MYRANGE_SET',
      payload: get(res, 'data.data', [])
    });
    return res;
  });
};

export const loadInvite = (inviteCode) => (dispatch, getState) => {
  let { jwToken } = getState();

  return getRankingByInviteCode(jwToken, inviteCode).then(res => {
    const total = get(res, 'data.total', 0);
    if (total === 0) {
      dispatch({ type: 'RANKING_INVITE_NOT_FOUND' })
    } else {
      window.localStorage.setItem(INVITE_LOCALSTORAGE_KEY, inviteCode);
      dispatch({
        type: 'RANKING_INVITE_SET',
        payload: get(res, 'data.data[0]')
      });
    }
    return res;
  });
};